var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidbaricon33(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 5.71288C1.3335 4.91542 1.65508 4.42671 2.32058 4.05635L5.06008 2.53179C6.49556 1.73293 7.2133 1.3335 8.00016 1.3335C8.78703 1.3335 9.50476 1.73293 10.9402 2.53179L13.6798 4.05635C14.3452 4.42671 14.6668 4.91543 14.6668 5.71288C14.6668 5.92912 14.6668 6.03724 14.6432 6.12612C14.5192 6.59313 14.096 6.66683 13.6873 6.66683H2.31302C1.90434 6.66683 1.48118 6.59312 1.35711 6.12612C1.3335 6.03724 1.3335 5.92912 1.3335 5.71288Z",
    stroke: "#686C70",
    strokeWidth: 1.0625
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99756 4.6665H8.00393",
    stroke: "#686C70",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 6.6665V12.3332M5.33317 6.6665V12.3332",
    stroke: "#686C70",
    strokeWidth: 1.0625
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 6.6665V12.3332M13.3332 6.6665V12.3332",
    stroke: "#686C70",
    strokeWidth: 1.0625
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6668 12.3335H3.3335C2.22893 12.3335 1.3335 13.2289 1.3335 14.3335C1.3335 14.5176 1.48274 14.6668 1.66683 14.6668H14.3335C14.5176 14.6668 14.6668 14.5176 14.6668 14.3335C14.6668 13.2289 13.7714 12.3335 12.6668 12.3335Z",
    stroke: "#686C70",
    strokeWidth: 1.0625
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidbaricon33);
export default __webpack_public_path__ + "static/media/sidbaricon33.2fdd4592051b529bfae95dfb126340f3.svg";
export { ForwardRef as ReactComponent };